import { useRouteError, useNavigate } from 'react-router';
import { Box, Button, Typography } from '@mui/material';

const RouterErrorFallback: React.FC = () => {
    const error = useRouteError() as Error | { statusText?: string; data?: string };
    const navigate = useNavigate();

    const getErrorMessage = () => {
        if ('message' in error && error.message) return error.message;
        if ('statusText' in error && error.statusText) return error.statusText;
        if ('data' in error && error.data) return error.data;
        return 'An unexpected error occurred';
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '50vh',
                p: 3,
                gap: 1,
            }}
        >
            <Typography variant="h2" gutterBottom>
                Something went wrong
            </Typography>
            <Typography variant="body1" component="pre" sx={{ textAlign: 'center' }}>
                {getErrorMessage()}
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                Return to home
            </Button>
        </Box>
    );
};

export default RouterErrorFallback;
